import { render, staticRenderFns } from "./deleteResourceStoreType.vue?vue&type=template&id=3753ad78&scoped=true"
import script from "./deleteResourceStoreType.vue?vue&type=script&lang=js"
export * from "./deleteResourceStoreType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753ad78",
  null
  
)

export default component.exports